import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button, Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import privacyPolicyHtml_de from './PrivacyPolicyHtml_de';
import privacyPolicyHtml_en from './PrivacyPolicyHtml_en';

const PrivacyPolicyDialog = props => {
    const [visible, setVisible] = React.useState(props.visible);
    const userProfile = useSelector(state => state.profile.profile);

    const localizedPrivacyPolicyHtml = userProfile && userProfile.userLanguage == window.enumLanguage['German'] ? { __html: privacyPolicyHtml_de } : { __html: privacyPolicyHtml_en };

    const handleClose = () => {
        if (props.onClose)
            props.onClose(false);
    };

    const handleCancel = (event) => {
        event.preventDefault();
        if (props.onCancel)
            props.onCancel();
        else if (props.onClose)
            props.onClose(false);
    };

    const handleConfirm = (event) => {
        event.preventDefault();
        if (props.onClose)
            props.onClose(true);
    };

    React.useEffect(() => {
        setVisible(props.visible);
    }, [props.visible]);

    return (
        <div>
            {visible && (
                <Dialog title={<FormattedMessage id='CookieConsent.PrivacyPolicy' />} onClose={handleClose}>
                    <Row>
                        <Col xs="12">
                            <div
                                dangerouslySetInnerHTML={localizedPrivacyPolicyHtml}
                            />
                        </Col>
                    </Row>                    
                    <DialogActionsBar>
                        <Button type={"submit"} color="secondary" onClick={handleCancel}>
                            <FormattedMessage id='Control.Close' />
                        </Button>
                        <Button type={"submit"} color="primary" onClick={handleConfirm}>
                            <FormattedMessage id='CookieConsent.Accept' />
                        </Button>
                    </DialogActionsBar>
                </Dialog>
            )}
        </div>
    );
};

export default PrivacyPolicyDialog